import { nextTick, Ref } from "@vue/composition-api";

export function useMessage(messageElement: Ref<HTMLInputElement | undefined>, messageContent: Ref<string>) {
    const insertToMessage = (insertText: string, trim?: boolean) => {
        const caretPosition = messageElement.value?.selectionStart ?? messageContent.value.length;

        let startText = messageContent.value.substring(0, caretPosition);
        let endText = messageContent.value.substring(caretPosition, messageContent.value.length);

        if (trim) {
            startText = startText.trimEnd();
            endText = endText.trimStart();
            insertText = ` ${insertText} `;
        }

        // Refs do not update in the same tick so make an extra value to make sure .trim does not overwrite anything
        let newContent = `${startText}${insertText}${endText}`;

        if (trim) {
            newContent = newContent.trim();
        }

        messageContent.value = newContent;

        const nextCursorPosition = caretPosition + insertText.length;

        messageElement.value?.focus();
        nextTick(() => messageElement.value?.setSelectionRange(nextCursorPosition, nextCursorPosition));
    };

    return {
        insertToMessage,
    };
}
